import React from 'react';
import { t } from '../../../i18n';
import CustomButton from '../../../components/CustomButton/CustomButton.component';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio
} from '@material-ui/core';
import { APP_CONSTANT } from 'src/constants';
import { useStyles } from '../Login.style';

interface MethodSelectionPopupProps {
  showMethodPopup: boolean;
  setShowMethodPopup(isShow: boolean): void;
  handleSelectMethod(event: any): void;
  value: string;
  phoneNumber: string;
  email: string;
  sendMethod(hasPhoneNumber: boolean): void;
}

const MethodSelectionPopup: React.FC<MethodSelectionPopupProps> = (props) => {
  const {
    showMethodPopup,
    setShowMethodPopup,
    handleSelectMethod,
    value,
    phoneNumber,
    email,
    sendMethod
  } = props;
  const classes = useStyles();

  const handleConfirmMethod = () => {
    setShowMethodPopup(false);
    sendMethod(true);
  };

  const handleCancel = () => {
    setShowMethodPopup(false);
    handleSelectMethod({ target: { value: APP_CONSTANT.SMS } });
  };

  const formatPhoneNumber = (num) => num.slice(num.length - 4);

  return (
    <Dialog
      open={showMethodPopup}
      onClose={handleCancel}
      PaperProps={{
        style: { borderRadius: 10 }
      }}
    >
      <DialogTitle id="alert-dialog-title" className={classes.popupTitle}>
        <p className={classes.popupTitleText}>{t('signIn.selectMethod')}</p>
      </DialogTitle>
      <DialogContent className={classes.popupContent}>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="verificationMethod"
            name="verificationMethod"
            value={value}
            onChange={handleSelectMethod}
          >
            <FormControlLabel
              value={APP_CONSTANT.SMS}
              control={<Radio color="primary" />}
              label={t('signIn.smsChoice', {
                phoneNumber: formatPhoneNumber(phoneNumber)
              })}
              className={classes.formLabelOption}
            />
            <FormControlLabel
              value={APP_CONSTANT.EMAIL}
              control={<Radio color="primary" />}
              label={t('signIn.emailChoice', {
                email
              })}
              className={classes.formLabelOption}
            />
          </RadioGroup>
        </FormControl>
      </DialogContent>
      <DialogActions className={classes.popupButton}>
        <CustomButton
          title={t('general.cancel')}
          variant="outlined"
          onClick={handleCancel}
          isCancel={true}
        />
        <CustomButton
          title={t('general.confirm')}
          variant="outlined"
          onClick={handleConfirmMethod}
          color="primary"
        />
      </DialogActions>
    </Dialog>
  );
};

export default MethodSelectionPopup;
